export default class CustomerFiltersViewModel {
    isActive: boolean = false;
    customerID: string = '';
    telephone: string = '';
    clientRef: string = '';
    urn: string = '';
}